import { BucketTypeEnum, IBucketResponseSchema } from '@monetize/types/app';
import { createColumnHelper } from '../../../components/Monetize/DataTableNew/appTable';
import { actionCatalogColumn } from '../../../components/Monetize/DataTableNew/columnCatalog/structuralColumns';
import {
  ColumnCatalog,
  ColumnContextBase,
} from '../../../components/Monetize/DataTableNew/columnCatalog/types';
import {
  checkboxBodyTemplate,
  dateTimeBodyTemplate,
  enumDisplayBodyTemplate,
  getColHeaderFilters,
  getColHeaderWithSize,
  getColumnFilterValuesForEnum,
  nameWithIdBodyTemplate,
} from '../../../components/Monetize/DataTableNew/tableUtilsNew';
import { BUCKET_TYPE_ENUM_DISPLAY } from '../../../constants/buckets';
import { getBucketEditRoute } from '../../../constants/routes';

const columnHelper = createColumnHelper<IBucketResponseSchema>();

export type BucketListColumnContext = ColumnContextBase<IBucketResponseSchema>;

/** tableId: FilterStateKeys.BUCKET_LIST */
export const BUCKET_LIST_CATALOG: ColumnCatalog<
  IBucketResponseSchema,
  BucketListColumnContext
> = [
  {
    id: 'name',
    label: 'Bucket Name',
    customizable: false,
    build: () =>
      columnHelper.accessor('name', {
        ...getColHeaderWithSize('Bucket Name', 300),
        cell: nameWithIdBodyTemplate<IBucketResponseSchema, unknown>({
          idProp: 'id',
          nameProp: 'name',
          idLinkFn: (id) => getBucketEditRoute(id),
        }),
        enableSorting: true,
        sortFn: 'text',
      }),
  },
  {
    id: 'type',
    label: 'Bucket Type',
    build: () =>
      columnHelper.accessor('type', {
        ...getColHeaderWithSize('Bucket Type', 150),
        ...getColHeaderFilters('SET', {
          predefinedFilterValues: getColumnFilterValuesForEnum(
            BucketTypeEnum,
            BUCKET_TYPE_ENUM_DISPLAY,
          ),
        }),
        cell: enumDisplayBodyTemplate({
          displayMap: BUCKET_TYPE_ENUM_DISPLAY,
        }),
        enableSorting: true,
        sortFn: 'text',
      }),
  },
  {
    id: 'modifyDate',
    label: 'Updated',
    build: () =>
      columnHelper.accessor('modifyDate', {
        header: 'Updated',
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        size: 180,
        enableSorting: true,
      }),
  },
  {
    id: 'createDate',
    label: 'Created',
    build: () =>
      columnHelper.accessor('createDate', {
        header: 'Created',
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
        size: 180,
        enableSorting: true,
      }),
  },
  {
    id: 'locked',
    label: 'Locked',
    build: () =>
      columnHelper.accessor('locked', {
        header: 'Locked',
        ...getColHeaderFilters('BOOLEAN'),
        cell: checkboxBodyTemplate(),
        size: 100,
        enableSorting: true,
      }),
  },
  actionCatalogColumn<IBucketResponseSchema>(),
];
